import { render, staticRenderFns } from "./terms.html?vue&type=template&id=fa9baca8&scoped=true&"
import script from "./terms.js?vue&type=script&lang=js&"
export * from "./terms.js?vue&type=script&lang=js&"
import style0 from "./terms.scss?vue&type=style&index=0&id=fa9baca8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9baca8",
  null
  
)

export default component.exports